import React from "react";
import { Form } from "semantic-ui-react";
import { useExtLabels } from "../../common/extLabels";

const Agreements = ({ model, errors = {}, onChange, disabled, termsAndConditions }) => {
    const l = useExtLabels();

    const handleChange = (name, value) => onChange({ ...model, [name]: value });

    return (
        <React.Fragment>
            <Form.Checkbox
                disabled={disabled}
                label="akceptuję regulamin Konkursu"
                error={!!errors.termsAndConditions}
                name="termsAndConditions"
                checked={model.termsAndConditions}
                onChange={(target, { name, checked }) => handleChange(name, checked)}
                required
            />
            <Form.Checkbox
                disabled={disabled}
                label={l("Chcę otrzymywać na adres e-mail informacje o innych aktywnościach Izby Gospodarki Elektronicznej, jak w szczególności o konkursach, konferencjach, galach i raportach. Zawsze mogę wycofać tę zgodę.	")}
                error={!!errors.notifyAboutOtherActivities}
                name="notifyAboutOtherActivities"
                checked={model.notifyAboutOtherActivities}
                onChange={(target, { name, checked }) => handleChange(name, checked)}
            />
            <Form.Checkbox
                disabled={disabled}
                label={
                    <label>
                        Administratorem Twoich danych osobowych jest Izba Gospodarki Elektronicznej.{" "}
                        <a href={"https://eizba.pl/polityka-prywatnosci/"} target="_blank">
                        Kliknij i dowiedz się więcej m.in. po co nam Twoje dane i jakie masz prawa
                        </a>
                    </label>
                }
                error={!!errors.notifyAboutCompetition}
                name="notifyAboutCompetition"
                checked={model.notifyAboutCompetition}
                onChange={(target, { name, checked }) => handleChange(name, checked)}
                required
            />
        </React.Fragment>
    );
};

export default Agreements;
